import React from "react";
import { Box, Container, Flex, Text, Image } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const Header: React.FC = () => {
    const primaryColor = "#1d4e4e";
    const textColor = "#333333";
    const white = "#ffffff";

    return (
        <Box
            as="header"
            bg={white}
            boxShadow="0 2px 4px rgba(0, 0, 0, 0.1)"
            position="fixed"
            width="100%"
            top={0}
            zIndex={1000}
        >
            <Container maxW="1200px">
                <Flex justify="space-between" align="center" py={4}>
                    <RouterLink
                        to="/"
                        style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                    >
                        <Image src="/assets/logos/logo.png" alt="Grade-R Logo" w="40px" h="40px" />
                        <Text color={primaryColor} fontSize="1.5rem" fontWeight="700">
                            Grade-R
                        </Text>
                    </RouterLink>
                    <Flex gap={8}>
                        <RouterLink to="/help" style={{ color: textColor, fontWeight: 500 }}>
                            Help
                        </RouterLink>
                        <RouterLink to="/privacy" style={{ color: textColor, fontWeight: 500 }}>
                            Privacy Policy
                        </RouterLink>
                        <RouterLink to="/delete" style={{ color: textColor, fontWeight: 500 }}>
                            Account Deletion
                        </RouterLink>
                    </Flex>
                </Flex>
            </Container>
        </Box>
    );
};

export default Header;
